module.exports = __webpack_public_path__ + "613d1be527612606fb60d554ad43732d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/cover/turkey.jpg
// module id = 200
// module chunks = 0